import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CryptoIcon from 'react-crypto-icons';
import { BTCIcon } from './btc.js';
import { ETHIcon } from './eth.js';
import { XRPIcon } from './xrp.js';

const customIcons = {
  btc: BTCIcon,
  eth: ETHIcon,
  xrp: XRPIcon,
  // ...add other custom icons here...
};

const CryptoIconWrapper = ({ name, size }) => {
  const [iconLoaded, setIconLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIconLoaded(true);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  const IconComponent = customIcons[name?.toLowerCase()];
  return iconLoaded ? (
    IconComponent ? (
      <div style={{ height: `${size}px`, width: `${size}px` }}>
        <IconComponent size={size} />
      </div>
    ) : (
      <CryptoIcon name={name} size={size} />
    )
  ) : (
    <div style={{ height: `${size}px`, width: `${size}px` }} />
  );
};

CryptoIconWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};

export default CryptoIconWrapper;
